import { BrandMark } from "../components/BrandMark";

// Rendered when NO flag verdict exists for this account+user and the resolver couldn't answer
// (offline first sign-in, resolver outage). Fails CLOSED by design — capture never renders from
// an unverified default — but stays calm: this is a connectivity/policy-service problem, not the
// guard's fault. Reuses boot styling; the retry is a plain reload so the whole gate re-runs.

export function WebAccessUnverified({
  onSignOut,
  onRetry,
}: {
  onSignOut: () => void;
  onRetry: () => void;
}) {
  return (
    <div className="boot">
      <main className="boot__card" role="main" aria-labelledby="unverified-title">
        <BrandMark className="boot__mark" />
        <p className="boot__eyebrow">SecOps</p>
        <h1 id="unverified-title" className="boot__title">
          Guard Web
        </h1>
        <p className="boot__tagline">Can't verify web access right now.</p>
        <p className="boot__detail">
          Guard Web couldn't reach the policy service to confirm your team's web access. Check your
          connection and try again, or use the SecOps Guard app on your phone.
        </p>
        <div className="boot__actions">
          <button className="shell__statusbtn" type="button" onClick={onRetry}>
            Try again
          </button>
          <button className="shell__signout" type="button" onClick={onSignOut}>
            Sign out
          </button>
        </div>
      </main>
    </div>
  );
}
